import { classicProjectFieldsEntryPoint } from '@jira/project-settings__classic-project-fields/src/classicProjectFieldsEntryPoint.entrypoint.tsx';
import { classicProjectSettingsServiceDeskFieldsRoute } from '@jira/router-routes__classic-project-settings-fields-routes/src/classicProjectSettingsServiceDeskFieldsRoute.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';

import { GENERIC_PROJECT_HORIZONTAL_NAV } from '@jira/navigation-apps__horizontal-nav-selector/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import type { Route } from '@atlassian/react-resource-router';

const pageEntryPoint = createPageEntryPoint({
	main: classicProjectFieldsEntryPoint,
});
export const classicProjectSettingsServiceDeskFieldsRouteEntry: Route = createEntry(
	classicProjectSettingsServiceDeskFieldsRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'project-settings.fields.jsm-cmp',
		layout: serviceProjectLayout,
		navigation: {
			horizontal: GENERIC_PROJECT_HORIZONTAL_NAV,
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		canTransitionIn: () => !fg('mc-nfa-soft-rollback'),
		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		entryPoint: () => {
			if (fg('mc-nfa-soft-rollback')) {
				return undefined;
			}
			return pageEntryPoint;
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
		meta: {
			reporting: {
				packageName: 'jiraClassicProjectSettingsProjectFields',
				id: 'project-settings.fields.jsm-cmp',
				teamName: 'Yamato',
			},
		},
	}),
);
